var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "trash-svg",
    d: "M9.74 10.941h1.332l1.554 20.044C12.756 32.682 14.16 34 15.82 34h9.354c1.659 0 3.065-1.318 3.194-3.015l1.56-20.044h1.332c.407 0 .74-.342.74-.76a.752.752 0 0 0-.74-.76h-5.704v-.767C25.556 7.184 24.41 6 22.98 6H18.02c-1.43 0-2.577 1.185-2.577 2.654v.767H9.74a.752.752 0 0 0-.74.76c0 .418.333.76.74.76zM26.9 30.864a1.734 1.734 0 0 1-1.72 1.616h-9.354a1.74 1.74 0 0 1-1.72-1.616l-1.542-19.923h15.884l-1.547 19.923zm-9.976-22.21c0-.627.487-1.134 1.097-1.134h4.958c.61 0 1.097.507 1.097 1.134v.767h-7.152v-.767z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "trash-svg-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trash-svg"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F77777",
    fillRule: "nonzero",
    xlinkHref: "#trash-svg"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#trash-svg-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.adab4a3cdc0bc85e036db5bf1d3e9e78.svg";
export { ForwardRef as ReactComponent };